import React from 'react'
import { compose, graphql } from 'react-apollo'
import Gallery from 'react-photo-gallery'
import _get from 'lodash/get'

import eventBySlugQuery from '~/graphql/queries/eventBySlug.gql'
import searchPhotosQuery from '~/graphql/queries/searchPhotos.gql'

const apiUri = process.env.REACT_APP_PHOTO_API_URI
const baseUri = process.env.REACT_APP_PHOTO_BASE_URI

const RunnerPhotos = ({ event: eventData, data, bib }) => {
  const loading = _get(data, 'loading' )
  const event = _get(eventData, 'eventBySlug')
  const eventPhotos = _get(data, 'searchPhotos.items', [])
  const photos = eventPhotos.map(photo => ({
    ...photo,
    src: _get(photo, 'view.thumbnail.url'),
    width: _get(photo, 'view.thumbnail.size.width'),
    height: _get(photo, 'view.thumbnail.size.height')
  }))
  const handlePhotoClick = (ctx) => {
    window.open(`${baseUri}/${event.slug}?s=${bib}&pId=${_get(ctx, 'photo._id', '')}`)
  }
  if (loading) {
    return <div>Loading...</div>
  }
  if (!event) {
    return <div>Event not found Photos</div>
  }
  return <div className="section">
    <h2 className="sectionTitle">
      Photos
    </h2>
    <div className="sectionContent">
      {photos.length > 0
        ? <Gallery photos={photos} columns={4} margin={2} onClick={(e, ctx) => handlePhotoClick(ctx)} />
        : <div>ไม่พบภาพของท่าน กรุณาค้นหาที่ <a href={`${baseUri}/${event.slug}`} target="_blank">PHOTO.THAI.RUN</a></div>
      }
    </div>
  </div>
}

export default compose(
  graphql(eventBySlugQuery, {
    name: 'event',
    options: ({ slug }) => ({
      variables: {
        slug
      },
      context: {
        uri: apiUri
      },
    })
  }),
  graphql(searchPhotosQuery, {
    options: ({ event, bib }) => ({
      skip: !event.eventBySlug,
      variables: {
        eventId: _get(event, 'eventBySlug._id'),
        searchText: bib
      },
      context: {
        uri: apiUri
      }
    })
  })
)(RunnerPhotos)